import { Box, Table, TableBody, TableHead, TableRow, Typography } from '@mui/material';
import { GeneralTableBox, HeadTableCell, RowTableCell } from '../../../common/components';
import { MESSAGES } from '../constants/collectingEntitiesConstants';

const CollectionsSummaryTable = ({ header, results = [], totals, groupColumns }) => {
  const hasData = results && results.length > 0;

  return (
    <GeneralTableBox
      sx={{
        minHeight: hasData ? 'auto' : '200px',
        p: 3,
        justifyContent: hasData ? 'flex-start' : 'center',
      }}
    >
      {!hasData ? (
        <Typography variant="body1" color="text.secondary">
          {MESSAGES.EMPTY_STATE}
        </Typography>
      ) : (
        <>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {header?.plan_name || 'Plan seleccionado'}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
              Resumen de Cobranzas
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {header?.date_filter_text || 'Sin filtros de fecha'}
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 2,
              mb: 2,
            }}
          >
            <Typography variant="body2">
              <strong>Entidad:</strong> {header?.legal_entity_name || 'Todas'}
            </Typography>
            <Typography variant="body2">
              <strong>Actualizado:</strong> {header?.updated_at_date || '-'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {header?.constructora_info}
            </Typography>
          </Box>

          <Table size="small">
            <TableHead>
              <TableRow>
                <HeadTableCell>Entidad</HeadTableCell>
                {groupColumns.map((column) => (
                  <HeadTableCell key={column} align="right">
                    {column}
                  </HeadTableCell>
                ))}
                <HeadTableCell align="right">Total</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results.map((row) => (
                <TableRow key={row.legal_entity_uuid} hover>
                  <RowTableCell>{row.legal_entity_name}</RowTableCell>
                  {groupColumns.map((column) => (
                    <RowTableCell key={`${row.legal_entity_uuid}-${column}`} align="right">
                      {row.groups?.[column] ?? 0}
                    </RowTableCell>
                  ))}
                  <RowTableCell align="right">{row.total}</RowTableCell>
                </TableRow>
              ))}
              <TableRow selected>
                <RowTableCell sx={{ fontWeight: 'bold' }}>TOTALES</RowTableCell>
                {groupColumns.map((column) => (
                  <RowTableCell key={`total-${column}`} align="right" sx={{ fontWeight: 'bold' }}>
                    {totals?.groups?.[column] ?? 0}
                  </RowTableCell>
                ))}
                <RowTableCell align="right" sx={{ fontWeight: 'bold' }}>
                  {totals?.total ?? 0}
                </RowTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </>
      )}
    </GeneralTableBox>
  );
};

export default CollectionsSummaryTable;
